import {
    GET_ASSIGNMENT_TRANSFER_TYPES,
    SET_ASSIGNMENT_TRANSFER_TYPES
} from "./AssignmentTransferTypesType"

const getAssignmentTransferTypes = () => ({
    type: GET_ASSIGNMENT_TRANSFER_TYPES
});

const setAssignmentTransferTypes = (assignmentTransferTypesList: any) => ({
    type: SET_ASSIGNMENT_TRANSFER_TYPES,
    assignmentTransferTypesList: assignmentTransferTypesList
});

export {
    getAssignmentTransferTypes,
    setAssignmentTransferTypes
}
